<template>
 <div>
    <div
      class="poster-content"
      :style="{
        maxHeight,
      }"
    >
      <div class="poster-title">
         <img :src="posterTitleImg" alt="">
      </div>
      <div class="poster-company-info">
         <div class="poster-company-info-top">
            <div class="poster-company-info-top-left">
                <img
                    :src="`https://scm.superboss.cc/api/wx/unAuth/proxy.json?pic=${wxCodeUrl}`"
                />
                <div class="poster-company-info-top-left-tip">长按扫码看好货</div>
            </div>
            <div class="poster-company-info-top-right"> {{this.cardName || userInfo.companyName}}</div>
         </div>
         <div 
            v-if="goodsConfiguration.deliveryItemCount30D || goodsConfiguration.deliverRate48H || goodsConfiguration.deliverRate24H"
            class="poster-company-info-bottom" 
         >
            <div class="poster-company-info-bottom-lable">服务能力：</div>
            <div class="poster-company-info-bottom-right">
                <div class="poster-company-info-bottom-item">
                    <div class="poster-company-info-bottom-item-num">{{numberTransform(goodsConfiguration.deliveryItemCount30D)}}</div>
                    <div class="poster-company-info-bottom-item-text">月均发货单</div>
                </div>
                <div class="poster-company-info-bottom-item">
                    <div class="poster-company-info-bottom-item-num" style="color:#FF112C;">{{goodsConfiguration.deliverRate48H}}%</div>
                    <div class="poster-company-info-bottom-item-text">48h发货率</div>
                </div>
                <div class="poster-company-info-bottom-item">
                    <div class="poster-company-info-bottom-item-num" style="color:#FF112C;">{{goodsConfiguration.deliverRate24H}}%</div>
                    <div class="poster-company-info-bottom-item-text">24h揽收率</div>
                </div>
            </div>
         </div>
         <div 
            v-if="goodsConfiguration.distributeGoodCount || goodsConfiguration.monthlyGoodUpdate || goodsConfiguration.avgSupplyPrice"
            class="poster-company-info-bottom"
         >
            <div class="poster-company-info-bottom-lable">商品能力：</div>
            <div class="poster-company-info-bottom-right">
                <div class="poster-company-info-bottom-item">
                    <div class="poster-company-info-bottom-item-num" style="color:#FF112C;">{{numberTransform(goodsConfiguration.distributeGoodCount)}}</div>
                    <div class="poster-company-info-bottom-item-text">可分销商品</div>
                </div>
                <div class="poster-company-info-bottom-item">
                    <div class="poster-company-info-bottom-item-num">{{numberTransform(goodsConfiguration.monthlyGoodUpdate)}}</div>
                    <div class="poster-company-info-bottom-item-text">商品月上新</div>
                </div>
                <div class="poster-company-info-bottom-item">
                    <div class="poster-company-info-bottom-item-num">{{numberTransform(goodsConfiguration.avgSupplyPrice)}}</div>
                    <div class="poster-company-info-bottom-item-text">供货平均单价</div>
                </div>
            </div>
         </div>
      </div>
      <div class="poster-goods-list">
        <template v-if="goodsList.length === 0">
          <img
            width="100%"
            src="https://img.alicdn.com/imgextra/i1/2211227103034/O1CN012lJCiP1YHcRKrMD6W_!!2211227103034.png"
            alt=""
          >
        </template>
        <template v-else>
            <template v-if="editing">
                <div 
                    v-for="(item, index) in editingGoodsList"
                    :key="item.baseItemId"
                    class="poster-goods-item"
                >
                    <i
                        v-if="editingGoodsList.length > 1"
                        class="el-icon-remove text-red absolute remove-icon text-pointer ftsz20"
                        @click="deleteGoods(index)"
                    />
                    <div class="absolute move-icon ftsz18 text-666">
                        <img
                            width="20px"
                            src="https://img.alicdn.com/imgextra/i2/2211227103034/O1CN01fw1rtH1YHcRkh09IY_!!2211227103034.png"
                            v-if="index > 0"
                            class="mgb12 text-pointer"
                            @click="moveUp(index)"
                        />
                        <br />
                        <img
                            width="20px"
                            src="https://img.alicdn.com/imgextra/i2/2211227103034/O1CN01eZ7mS21YHcRmtGTlp_!!2211227103034.png"
                            v-if="index < editingGoodsList.length - 1"
                            class="text-pointer"
                            @click="moveDown(index)"
                        />
                    </div>
                    <div class="poster-goods-item-left">
                        <img 
                            :src="getMainImage(item.mainImages)"
                            @error="imgOnError($event)"
                        >
                        <div v-if="calculateDateDifference(item.distributionTime) < 30" class="poster-goods-item-tag new">新品</div>
                        <div class="poster-goods-item-tag recommend" v-else>推荐</div>
                    </div>
                    <div class="poster-goods-item-right">
                        <div class="poster-goods-item-title">{{item.title}}</div>
                        <div class="poster-goods-item-tag-box">
                            <span v-if="calculateDateDifference(item.distributionTime) < 30" class="poster-goods-item-goods-tag new">30天上新</span>
                            <span v-if="numberTransform((item.supplyOperateDataVo || {}).soldQuantity30D) != '--'" class="poster-goods-item-goods-tag sales" style="margin-left:6px;">月销量{{numberTransform((item.supplyOperateDataVo || {}).soldQuantity30D)}}</span>
                        </div>
                        <div class="poster-goods-item-price">
                            分销价<span class="price">{{item.levelDistributionPrice}}</span>
                        </div>
                        <div class="poster-goods-item-discount-tag">合作后更优惠</div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div 
                    v-for="(item) in goodsList"
                    :key="item.baseItemId"
                    class="poster-goods-item"
                >
                    <div class="poster-goods-item-left">
                        <img 
                            :src="getMainImage(item.mainImages)"
                            @error="imgOnError($event)"
                        >
                        <div v-if="calculateDateDifference(item.distributionTime) < 30" class="poster-goods-item-tag new">新品</div>
                        <div class="poster-goods-item-tag recommend" v-else>推荐</div>
                    </div>
                    <div class="poster-goods-item-right">
                        <div class="poster-goods-item-title">{{item.title}}</div>
                        <div class="poster-goods-item-tag-box">
                            <span v-if="calculateDateDifference(item.distributionTime) < 30" class="poster-goods-item-goods-tag new">30天上新</span>
                            <span v-if="numberTransform((item.supplyOperateDataVo || {}).soldQuantity30D) != '--'" class="poster-goods-item-goods-tag sales" style="margin-left:6px;">月销量{{numberTransform((item.supplyOperateDataVo || {}).soldQuantity30D)}}</span>
                        </div>
                        <div class="poster-goods-item-price">
                            分销价<span class="price">{{item.levelDistributionPrice}}</span>
                        </div>
                        <div class="poster-goods-item-discount-tag">合作后更优惠</div>
                    </div>
                </div>
            </template>
        </template>
      </div>
    </div>
    <!-- 隐藏的海报，下载用 -->
    <div class="poster-content hide absolute" :id="canvasId">
      <div class="poster-title">
         <img :src="posterTitleImg" alt="">
      </div>
      <div class="poster-company-info">
         <div class="poster-company-info-top">
            <div class="poster-company-info-top-left">
                <img
                    :src="`https://scm.superboss.cc/api/wx/unAuth/proxy.json?pic=${wxCodeUrl}`"
                />
                <div class="poster-company-info-top-left-tip">长按扫码看好货</div>
            </div>
            <div class="poster-company-info-top-right"> {{this.cardName || userInfo.companyName}}</div>
         </div>
         <div 
            v-if="goodsConfiguration.deliveryItemCount30D || goodsConfiguration.deliverRate48H || goodsConfiguration.deliverRate24H"
            class="poster-company-info-bottom" 
         >
            <div class="poster-company-info-bottom-lable">服务能力：</div>
            <div class="poster-company-info-bottom-right">
                <div class="poster-company-info-bottom-item">
                    <div class="poster-company-info-bottom-item-num">{{numberTransform(goodsConfiguration.deliveryItemCount30D)}}</div>
                    <div class="poster-company-info-bottom-item-text">月均发货单</div>
                </div>
                <div class="poster-company-info-bottom-item">
                    <div class="poster-company-info-bottom-item-num" style="color:#FF112C;">{{goodsConfiguration.deliverRate48H}}%</div>
                    <div class="poster-company-info-bottom-item-text">48h发货率</div>
                </div>
                <div class="poster-company-info-bottom-item">
                    <div class="poster-company-info-bottom-item-num" style="color:#FF112C;">{{goodsConfiguration.deliverRate24H}}%</div>
                    <div class="poster-company-info-bottom-item-text">24h揽收率</div>
                </div>
            </div>
         </div>
         <div 
            v-if="goodsConfiguration.distributeGoodCount || goodsConfiguration.monthlyGoodUpdate || goodsConfiguration.avgSupplyPrice"
            class="poster-company-info-bottom"
         >
            <div class="poster-company-info-bottom-lable">商品能力：</div>
            <div class="poster-company-info-bottom-right">
                <div class="poster-company-info-bottom-item">
                    <div class="poster-company-info-bottom-item-num" style="color:#FF112C;">{{numberTransform(goodsConfiguration.distributeGoodCount)}}</div>
                    <div class="poster-company-info-bottom-item-text">可分销商品</div>
                </div>
                <div class="poster-company-info-bottom-item">
                    <div class="poster-company-info-bottom-item-num">{{numberTransform(goodsConfiguration.monthlyGoodUpdate)}}</div>
                    <div class="poster-company-info-bottom-item-text">商品月上新</div>
                </div>
                <div class="poster-company-info-bottom-item">
                    <div class="poster-company-info-bottom-item-num">{{numberTransform(goodsConfiguration.avgSupplyPrice)}}</div>
                    <div class="poster-company-info-bottom-item-text">供货平均单价</div>
                </div>
            </div>
         </div>
      </div>  
      <div class="poster-goods-list">
        <div 
            v-for="(item) in goodsList"
            :key="item.baseItemId"
            class="poster-goods-item"
        >
            <div class="poster-goods-item-left">
                <img 
                    :src="getMainImage(item.mainImages)"
                    @error="imgOnError($event)"
                >
                <div v-if="calculateDateDifference(item.distributionTime) < 30" class="poster-goods-item-tag new">新品</div>
                <div class="poster-goods-item-tag recommend" v-else>推荐</div>
            </div>
            <div class="poster-goods-item-right">
                <div class="poster-goods-item-title">{{item.title}}</div>
                <div class="poster-goods-item-tag-box">
                    <span v-if="calculateDateDifference(item.distributionTime) < 30" class="poster-goods-item-goods-tag new">30天上新</span>
                    <span v-if="numberTransform((item.supplyOperateDataVo || {}).soldQuantity30D) != '--'" class="poster-goods-item-goods-tag sales" style="margin-left:6px;">月销量{{numberTransform((item.supplyOperateDataVo || {}).soldQuantity30D)}}</span>
                </div>
                <div class="poster-goods-item-price">
                    分销价<span class="price">{{item.levelDistributionPrice}}</span>
                </div>
                <div class="poster-goods-item-discount-tag">合作后更优惠</div>
            </div>
        </div>
      </div>
    </div>
 </div>
    
</template>

<script>
import { mapGetters } from 'vuex';
import { getMainImage } from '@/utils/index';
import posterTitleImg from '@/assets/images/newYearsGoodsFestivalTempTitle.png'
import { getShowCooperationIntention} from '@servers/commodity'
import no_pic from "@/assets/images/no_pic.png";
export default {
  props: {
    maxHeight: {
        default: 'fit-content',
        type: String,
    },
    cardName: {
        type: String,
        default: '',
    },
    wxCodeUrl: {
        type: String,
        default: '',
    },
    editing: {
        type: Boolean,
        default: false,
    },
    canvasId: {
      default: 'poster',
      type: String,
    },
    goodsList: {
        type: Array,
        default() {
        return []
        }
    },
    editingGoodsList: {
        type: Array,
        default() {
            return []
        }
    },
  },
  watch: {
  },
  data() {
    return {
      posterTitleImg,
      dialogVisible: false,
      temp:1,
      goodsConfiguration:{},
    };
  },
  computed: {
    ...mapGetters([
        "userInfo",
    ]),
  },
  components: {},
  created() {
    this.getCooperationIntention();
  },
  methods: {
    deleteGoods(index){
        this.$emit('deleteGoods', index)
    },
    moveUp(index){
        this.$emit('moveUp', index)
    },
    moveDown(index){
        this.$emit('moveDown', index)
    },
    getMainImage,
    imgOnError(e) {
      console.log(e);
      let img = e.srcElement;
      img.src = no_pic;
      img.onerror = null; //防止闪图
    },
    numberTransform(num){
        let result = num || '--';
        if(num > 99 && num < 10000){
            result = ~~(num/100) * 100
            return result + '+';
        }
        if(num > 9999){
            result = ~~(num/10000)
            return result + '万+';
        }
        return result;
    },
    // 计算时间差
    calculateDateDifference(date1) {
        // 创建Date对象
        const date1Obj = new Date(date1);
        const date2Obj = new Date();
        // 计算时间差（毫秒）
        const timeDifference = date2Obj - date1Obj;
        // 将时间差转换为天数
        const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        console.log('daysDifference:',daysDifference)
        return daysDifference;
    },
    async getCooperationIntention(){
        let res = await getShowCooperationIntention() || {};
        this.goodsConfiguration = {
            ...res
        }
    }
  },
};
</script>

<style lang="scss" scoped>
.poster-content {
    width: 520px;
    padding: 32px 34px 32px 20px;
    height: fit-content;
    overflow-y: auto;
    background: #ff4a40;
    background-image:url('../../assets/images/newYearsGoodsFestivalTempBg1.png'),url('../../assets/images/newYearsGoodsFestivalTempBg2.png');
    background-position: left top, left bottom; 
    background-size: 100% auto, 100% auto; 
    // background-size: contain, contain; 
    background-repeat: no-repeat, no-repeat;
    &.hide {
        // width: 520px;
        height: fit-content;
        max-height: fit-content;
        transform: scale(0.1) translateY(-250%);
        top: -50%;
        left: 0;
        z-index: -1;
    }
    .poster-title{
        text-align: center;
        margin-top: 18px;
        img{
            width: 318px;
        }
    }
    .poster-company-info{
        position: relative;
        background: linear-gradient(180deg, #FFEEEF 0%, #FFFFFF 77%);
        border-radius: 15px;
        padding-bottom: 20px;
        margin-bottom: 12px;
        .poster-company-info-top{
            position: relative;
            display: flex;
            margin-top: 36px;
            margin-bottom: 50px;
            padding: 12px 20px 12px 16px;
            .poster-company-info-top-left{
                position: relative;
                width: 122px;
                height: 122px;
                padding: 8px;
                margin-right: 20px;
                margin-top: -40px;
                background: #fff;
                border-radius: 50%;
                box-shadow: 0px 4px 10px 0px rgba(220, 163, 163, 0.41);
                // top: 30px;
                img{
                    width:100%;
                    border-radius: 50%;
                }
                .poster-company-info-top-left-tip{
                    position: absolute;
                    width: 144px;
                    line-height: 32px;
                    font-size: 14px;
                    color: #fff;
                    background: linear-gradient(91deg, #FF3B1D 0%, #FF7F7B 99%);
                    box-shadow: inset 0px -2px 4px 0px #FF5958;
                    border-radius: 20px;
                    bottom: -46px;
                }
                .poster-company-info-top-left-tip::before{
                    position: absolute;
                    content:'';
                    width: 0;
                    height: 0;
                    border-left: 6px solid transparent;
                    border-right: 6px solid transparent;
                    border-bottom: 8px solid #FF3B1D;
                    top:-7px;
                    left: 47px;
                }
            }
            .poster-company-info-top-right{
                display: -webkit-box;
                -webkit-line-clamp: 2; /* 限制显示的行数为3行 */
                -webkit-box-orient: vertical;
                overflow: hidden;
                height: 60px;
                font-size: 20px;
                font-weight: 600;
                text-align: left;
                flex: 1;
            }
        }
        .poster-company-info-bottom{
            display:flex;
            margin-top: 20px;
            padding: 0 20px 0 16px;
            .poster-company-info-bottom-lable{
                font-size: 14px;
                color: #6C6C6C;
                margin-right: 10px;
            }
            .poster-company-info-bottom-right{
                flex: 1;
                display: flex;
            }
            .poster-company-info-bottom-item{
                flex: 1;
                text-align: left;
            }
            .poster-company-info-bottom-item-num{
                font-size: 18px;
                font-weight: bold;
            }
            .poster-company-info-bottom-item-text{
                font-size: 14px;
                color: #6C6C6C;
            }
        }
    }
    .poster-goods-list{
        .poster-goods-item{
            position: relative;
            display: flex;
            padding: 14px;
            margin-top: 12px;
            background: #fff;
            border-radius: 14px;
            box-sizing: border-box;
            .poster-goods-item-left{
                position: relative;
                width: 140px;
                height: 140px;
                border-radius: 6px;
                img{
                    width: 100%;
                    height: 100%;
                    border-radius: 6px;
                }
                .poster-goods-item-tag{
                    position: absolute;
                    line-height: 22px;
                    font-size: 12px;
                    color:#fff;
                    padding: 1px 6px;
                    top: 0px;
                    left: 0px;
                    border-radius: 6px 0 6px 0;
                }
                .poster-goods-item-tag.new{
                    background: linear-gradient(242deg, #FFB36D -3%, #FF834A 47%, #FFB46D 92%);
                }
                .poster-goods-item-tag.recommend{
                    background: linear-gradient(242deg, #FF7C6D -3%, #FF504A 47%, #FF726D 92%);
                }

            }
            .poster-goods-item-right{
                flex: 1;
                margin-left: 12px;
                .poster-goods-item-title{
                    font-size: 14px;
                    display: -webkit-box;
                    -webkit-line-clamp: 2; /* 限制显示的行数为3行 */
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    height: 42px;
                    text-align: left;
                    color: #333333;
                }
                .poster-goods-item-price{
                    color: #FF112C;
                    font-size: 16px;
                    text-align: left;
                    margin-top: 6px;
                    .price{
                        font-size: 20px;
                        margin-left: 6px;
                        font-weight: bold;
                    }
                }
                .poster-goods-item-discount-tag{
                    width: 120px;
                    color: #FFFFFF;
                    font-size: 16px;
                    font-weight: bold;
                    padding: 2px 0;
                    margin-top:6px;
                    border: 2px solid;
                    background: linear-gradient(180deg, #FF4F35 0%, #FFA68E 100%);
                    border-radius: 40px;
                }
                .poster-goods-item-tag-box{
                    text-align: left;
                    margin-top: 4px;
                }
                .poster-goods-item-goods-tag{
                    display: inline-block;
                    font-size: 12px;
                    padding: 1px 2px;
                    border-radius: 4px;
                }
                .poster-goods-item-goods-tag.new{
                    color: #F97F65;
                    border:1px solid #FF8C00;
                }
                .poster-goods-item-goods-tag.sales{
                    color: #E85D58;
                    border: 1px solid #E85D58;
                }
            }
            .remove-icon {
                top: 2px;
                right: 2px;
            }
            .move-icon {
                top: 50%;
                transform: translateY(-50%);
                right: -24px;
            }
        }
    }
}
</style>
